/**
 * Supabase client.
 *
 * Phase 1 (mock) ─ services in this folder return mock data; this client is
 * created but never used unless VITE_USE_MOCK_AUTH=false AND env vars are set.
 *
 * Phase 2 ─ once you populate VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY,
 * service modules should switch from mock data to Supabase queries.
 *
 * NEVER import the service-role key into the browser. That key only belongs
 * in Supabase Edge Functions (configured via `supabase secrets set`).
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anon);

let _client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!isSupabaseConfigured) {
    throw new Error(
      'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env.local — or keep VITE_USE_MOCK_AUTH=true for Phase 1.',
    );
  }
  if (!_client) {
    _client = createClient(url!, anon!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return _client;
}
